import { Icon } from "@/components/icon/Icon";

/** 되돌아가는 줄. AppShell 을 안 쓰는 화면(주문 상세·공개 주문 폼)에는 탭 줄이
 *  없어서 여기가 유일한 출구다.
 *
 *  글자 "←" 를 쓰지 않는다: 폰트마다 굵기가 다르고, 눌리는 넓이가 글자 한 칸이라
 *  손가락으로 맞히기 어렵다. 아이콘 + 왼쪽으로 넘친 여백으로 44px 를 만든다. */
export function BackLink({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="-ml-2 inline-flex items-center gap-1 rounded-md py-2.5 pr-3 pl-2 text-label-1 text-label-alternative"
    >
      <Icon name="chevronLeft" size={16} />
      {label}
    </button>
  );
}

export default BackLink;
